 
export enum AuthenticationSource {
  WEB = 'WEB',
  ADMIN_PORTAL = 'ADMIN'
}
